import { Button, Input, Modal } from '@components';
import {
  NAME_MAX_LENGTH,
  NAME_MIN_LENGTH,
  SettlementMode
} from '@constants/generic';
import { nameRegex } from '@constants/regex';
import { BranchForm, ValidationError } from '@types';

interface CreateBranchModalProps {
  createBranchModalOpen: boolean;
  setCreateBranchModalOpen: (open: boolean) => void;
  setFormData: (data: BranchForm) => void;
  formData: BranchForm;
  onChangeBranchName: (value: string) => void;
  error: ValidationError;
  onBlurBranchName: (value: string) => void;
  onClickSave: () => void;
}

const CreateBranchModal = ({
  createBranchModalOpen,
  setCreateBranchModalOpen,
  setFormData,
  formData,
  onChangeBranchName,
  error,
  onBlurBranchName,
  onClickSave
}: CreateBranchModalProps) => {
  const handleCancel = () => {
    setCreateBranchModalOpen(false);
    setFormData({
      branchName: '',
      settlementMode: SettlementMode.BANK
    });
  };
  return (
    <Modal
      isOpen={createBranchModalOpen}
      onCancel={handleCancel}
      isCloseIconRequired
      closeIconClassName="!top-2"
      className="w-120 !bg-cofeeNeutral1"
    >
      <div className="border-b border-b-grey30">
        <div className="px-6 py-4 text-xl font-semibold text-cofeeNeutral10">
          New Branch
        </div>
      </div>
      <div className="px-6 py-4">
        <div className="mb-0.5 text-sm font-semibold text-cofeeNeutral10">
          Branch Name
        </div>
        <Input
          value={formData.branchName}
          inputStyle="!bg-cofeeNeutral1"
          handleInputChange={onChangeBranchName}
          placeholder="Enter branch name"
          inputRegex={nameRegex}
          minLength={NAME_MIN_LENGTH}
          maxLength={NAME_MAX_LENGTH}
          error={!!error.name}
          errorMessage={error.name}
          handleInputBlur={onBlurBranchName}
        />
      </div>
      <div className="flex w-full items-center justify-end gap-4 border-t border-cofeeNeutral4 px-6 py-4">
        <Button
          label="Cancel"
          size="medium"
          variant="tertiary"
          handleClick={handleCancel}
          labelStyle="!text-cofeeNeutral10 !font-medium"
        />
        <Button
          label="Create"
          size="medium"
          variant="primary"
          handleClick={onClickSave}
          disabled={formData.branchName.length < NAME_MIN_LENGTH}
        />
      </div>
    </Modal>
  );
};

export default CreateBranchModal;
